// Google Analytics（gtag.js）への送信。
// 画面遷移はページ全体の再読み込みを伴わないため、送信完了を待たずに遷移する。
// GAのスクリプトがブロックされていても画面操作を妨げないよう、例外は握りつぶす。

export const pageView = (title: string) => {
    try {
        gtag("event", "page_view", {
            page_title: title,
        })
    } catch {
        // 送信失敗は画面操作に影響させない
    }
}

type AnalyticsEventParams = Gtag.ControlParams & Gtag.EventParams & Gtag.CustomParams

export const trackEvent = (eventName: string, eventParams: AnalyticsEventParams = {}) => {
    try {
        gtag("event", eventName, eventParams)
    } catch {
        // 送信失敗は画面操作に影響させない
    }
}

export const trackButtonClick = (buttonName: string, screenName: string, destination?: string) => {
    const eventParams: AnalyticsEventParams = {
        button_name: buttonName,
        screen_name: screenName,
    }

    if (destination != null) {
        eventParams.destination = destination
    }

    trackEvent("button_click", eventParams)
}
